module.exports = "/static/assets/a86b4d64aa3808530d545e9d6442406d.png";